import React from 'react';
import { Column } from 'new/elements/Table/types';
import { SourceName } from 'new/elements/SourceName';
import { ChipBadge } from 'new/elements/ChipBadge';
import { DataSink } from 'new/entities/DataSink';

export const columns = [
  {
    name: 'Details',
    field: 'details',
    renderRow: (row) => {
      return <SourceName title={row.sinkName} type={'source'} icon={row.icon} name={row.name} />;
    },
  },
  {
    name: 'Status',
    field: 'statusInfo',
    renderRow: (row) => {
      return (
        <ChipBadge
          dot
          label={row.statusInfo.name}
          // @ts-ignore
          color={row.statusInfo.color}
        />
      );
    },
  },
  {
    name: 'Created on',
    field: 'createdAt',
  },
  {
    name: 'Identification',
    field: 'id',
    renderRow: (row) => <ChipBadge color="success" label={row.id + ''} />,
    center: true,
  },
] as Column<DataSink>[];
